import * as gfunctions from '../../../js/generalFunctions';

CCL.pdpSf = {
  autoload: [
    ['quantityRestrict', $('#alcoholAtcModal').length > 0],
    ['increment', $('#alcoholAtcModal').length > 0],
    ['decrement', $('#alcoholAtcModal').length > 0],
    ['allDisabled', $('.restrict-quantity').length > 0],
    ['checkConditions', $('.terms-conditions-btn').length > 0]
  ],

  increment() {
    $('body').on('click', '.increment-btn-1', (event) => {
      event.preventDefault();
      const targetElement = $(event.currentTarget).parents('.restrict-quantity').find('.quantity-input-1');
      let q = $(targetElement).val();
      const current = event.currentTarget;
      const arr = [];
      setTimeout(() => {
        $(targetElement).parents('.c-cart-card').find('.cart-edit-stateroom-wrap').css('display', 'block');
        $(targetElement).parents('.c-cart-card').find('.cart-edit-stateroom-link').attr('aria-expanded', 'true');
      }, 2000);
      if ($(targetElement).parents('.restrict-quantity').data('iscart') === (true || 'true')) {
        setTimeout(() => {
          $(event.target).parents('.restrict-quantity').after('<div class="sr-only" role="alert" aria-live="assertive">edit stateroom dropdown expanded</div>');
        }, 500);
      }
      $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each((index, element) => {
        let { qty } = element.dataset;
        if (qty === '') {
          qty = 2;
        }
        arr.push(qty);
        if (Number(qty) === 1) {
          $(element.parentElement).find('.alcohol-error-msg').show();
        }
      });
      if (arr.every(x => x >= 1)) {
        q = 1;
      } else if (q <= 1) {
        q++;
      }
      $(targetElement).val(q);
      this.disableButton(q, current);
      $(event.currentTarget).addClass('ada-element-focus');
      $(targetElement).attr('aria-label', `quantity value is ${q}`);
      $(event.currentTarget).attr('aria-label', `increment quantity with current value ${q}`);
      $(event.currentTarget).parents('.restrict-quantity').find('.decrement-btn-1').attr('aria-label', `decrement quantity with current value ${q}`);
      setTimeout(() => {
        $(event.currentTarget).focus();
      }, 100);
    });
  },
  decrement() {
    $('body').on('click', '.decrement-btn-1', (event) => {
      event.preventDefault();
      const current = event.currentTarget;
      const targetElement = $(event.target).parents('.restrict-quantity').find('.quantity-input-1');
      let q = $(targetElement).val();
      q--;
      const arr = [];
      $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each((index, element) => {
        const { qty } = element.dataset;
        arr.push(qty);
      });
      if (q === 0) {
        $('.decrement-btn-1').attr('disabled', 'disabled');
        return;
      }
      $(targetElement).val(q);
      this.disableButton(q, current);
      $(event.currentTarget).addClass('ada-element-focus');
      $(targetElement).attr('aria-label', `quantity value is ${q}`);
      $(event.currentTarget).attr('aria-label', `decrement quantity with current value ${q}`);
      $(event.currentTarget).parents('.restrict-quantity').find('.increment-btn-1').attr('aria-label', `increment quantity with current value ${q}`);
      setTimeout(() => {
        $(event.currentTarget).focus();
      }, 100);
    });
  },
  allDisabled() {
    const isCart = $('.restrict-quantity').data('iscart');
    if (isCart !== 'true' && isCart !== true) {
      const stateroomLength = $('.custom-control.custom-checkbox.stateroom-check').length;
      const disableLength = $('.custom-control.custom-checkbox.stateroom-check.stateroom-disabled').length;
      if (stateroomLength === disableLength) {
        $('.restrict-quantity').hide();
        $('.common-pdp-error-message').show();
        $('.pdp-error-msg').hide();
      } else {
        $('.common-pdp-error-message').hide();
        $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each((ind, ele) => {
          if ($(ele).data('qty') === '') {
            $(ele.parentElement.nextElementSibling).show();
          }
        });
      }
    }
  },
  checkConditions() {
    const hasVariant = $('#hasVariant').val();
    if ($('.flavor-wrap').length > 0) {
      if (hasVariant === 'false') {
        $('.terms-conditions-btn').removeAttr('disabled');
        if ($('.terms-conditions-btn').attr('data-bookingIds') === '') {
          $('.terms-conditions-btn').attr('disabled', 'disabled');
        }
      } else {
        $('.terms-conditions-btn').attr('disabled', 'disabled');
        $('.stateroom-check').addClass('stateroom-disabled');
        $('.stateroom-check .booking-toggle').removeAttr('tabindex');
        $('.stateroom-check').find('.parent-check').attr('disabled', 'disabled');
        $('.stateroom-check').find('.parent-check').removeAttr('checked');
        $('.guests-check').find('input').removeAttr('checked').attr('disabled', 'disabled');
        $('.inner-pdp-error-msg').hide();
        $('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg');
        $('.drop-icon').addClass('gray');
      }
    } else if ($('.terms-conditions-btn').attr('data-bookingIds') === '') {
      $('.terms-conditions-btn').attr('disabled', 'disabled');
    } else {
      $('.terms-conditions-btn').removeAttr('disabled');
    }
  },

  quantityRestrict() {
    $('body').on('click', '.add-to-cart-sf', (event) => {
      const csrf = $('.add-to-cart-sf').data('csrf') ? $('.add-to-cart-sf').data('csrf') : $('#csrfSessionToken').data('csrf');
      const targetElement = $(event.target).data('hasvariants');
      let dataObj = sessionStorage.getItem('sessionTemplateObj');
      const pageType = $('#pagetype').data('pagetype');
      dataObj = JSON.parse(dataObj);
      dataObj.pageType = pageType;
      if (pageType === 'CATEGORY') {
        dataObj.productPosition = Number(localStorage.getItem('productposition'));
        dataObj.pageNumber = Number(localStorage.getItem('pageNumber'));
        dataObj.categoryName = localStorage.getItem('sascategorycode');
      }
      dataObj = JSON.stringify(dataObj);
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: '/shop/cart/specialFS/add',
          contentType: 'application/json',
          data: dataObj,
          headers: {
            CSRFToken: csrf
          }
        }).done((response) => {
          if (response.addedToCart === true) {
            gfunctions.updateHeaderCartWidget(response);
            gfunctions.hideModal('alcoholAtcModal');
            CCL.addToCart.successModal(response);
          }
        }).fail(() => {
          console.log('Something went wrong');
        });
      }
    });
  },

  disableButton(inputVal, current) {
    if (Number(inputVal) === 1) {
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.decrement-btn-1').attr('disabled', 'disabled');
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.increment-btn-1').removeAttr('disabled');
    } else {
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.increment-btn-1').attr('disabled', 'disabled');
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.decrement-btn-1').removeAttr('disabled');
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-special-occassions-decors/pdp-special-occassions-decors.js